import { useEffect, useState } from 'react';
import api from '../../services/api';
import { resolveMediaUrl } from '../../utils/mediaUrl';

function progressFilename(src) {
  const s = String(src || '').trim();
  const m = s.match(/\/uploads\/(?:training-progress|progress)\/([^/?#]+)/i);
  return m?.[1] || null;
}

/**
 * Muestra fotos de progreso vía API autenticada (disco o respaldo base64 en BD).
 */
export default function ProgressPhotoImage({
  src,
  alt = 'Progreso',
  className = 'evidence-thumb mt-1',
  linkable = true,
  fallback,
  mediaApiBase = '/d28d/progress-photos',
}) {
  const [blobUrl, setBlobUrl] = useState('');
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = '';

    const load = async () => {
      const filename = progressFilename(src);
      if (!filename) {
        const direct = resolveMediaUrl(src);
        if (!direct) {
          if (!cancelled) setBroken(true);
          return;
        }
        if (!cancelled) setBlobUrl(direct);
        return;
      }

      try {
        const res = await api.get(`${mediaApiBase}/media/${encodeURIComponent(filename)}`, {
          responseType: 'blob',
        });
        objectUrl = URL.createObjectURL(res.data);
        if (!cancelled) {
          setBroken(false);
          setBlobUrl(objectUrl);
        }
      } catch {
        if (!cancelled) setBroken(true);
      }
    };

    setBlobUrl('');
    setBroken(false);
    load();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src, mediaApiBase]);

  if (broken || !blobUrl) {
    return fallback || (
      <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-3 mt-1">
        Imagen no disponible. El participante puede volver a subirla desde Mi Progreso.
      </p>
    );
  }

  const img = <img src={blobUrl} alt={alt} className={className} />;
  if (!linkable) return img;
  return (
    <a href={blobUrl} target="_blank" rel="noopener noreferrer">
      {img}
    </a>
  );
}

export { progressFilename };
